import { NgModule } from "@angular/core";

import {
    AjaxNg,
    CalculationRepository,
    ClientNg,
    MyProfileRepository,
    NgTranslations,
    ProductRepository,
    SalaxyContext,
    SalaxyErrorHandler,
    TaxCardRepository,
    Token,
    WorkerRepository,
    ContractRepository,
    OnboardingService,
} from "./index.services";

/**
 * Services module for Angular.io.
 * Can be used with either Ionic UX components (advanced with mobila capabilities)
 * or plain Angular components (simple, more a starting point implementation).
 */
@NgModule({
    declarations: [],
    exports: [],
    imports: [],
    providers: [
        AjaxNg,
        ClientNg,
        Token,
        NgTranslations,
        CalculationRepository,
        MyProfileRepository,
        ProductRepository,
        SalaxyContext,
        TaxCardRepository,
        WorkerRepository,
        ContractRepository,
        OnboardingService,
        SalaxyErrorHandler,
    ],
})
export class SalaxyNgServicesModule { }
